/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    taskCard: {
        width: '100%',
        padding: '12px',
        height: '48px',
        borderRadius: '8px',
        backgroundColor: tokens.colorNeutralBackground1,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'background-color 0.2s, box-shadow 0.2s',
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: tokens.colorNeutralBackground2,
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.18), 0px 0px 2px rgba(0, 0, 0, 0.12)'
        }
    },
    taskCircle: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '12px'
    },
    taskText: {
        flex: 1,
        height: '24px',
        opacity: 1,
        gap: '4px',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '20px',
        color: tokens.colorNeutralForeground1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
});
